import { NgClass, NgIf } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { SafePipe } from '@shared/pipe.safe';

@Component({
  selector: 'tnc-landing',
  standalone: true,
  imports: [NgIf, NgClass, SafePipe],
  templateUrl: './tnc-landing.component.html',
  styleUrl: './tnc-landing.component.scss'
})
export class TncLandingComponent {
  termsTitle = input<string>();
  termsContent = input<string>();
  buttonTextHide = input<string>();
  buttonTextShow = input<string>();

  // Output untuk komunikasi dengan parent component
  promoInteraction = output<{action: string, label?: string}>();

  isMore:boolean = false;

  toggleTerms() {
    this.isMore = !this.isMore;
    // Emit tracking event ke parent component
    this.promoInteraction.emit({
      action: this.isMore ? 'expand_terms' : 'collapse_terms',
      label: 'Terms and Conditions'
    });
  }
}
